import { render, staticRenderFns } from "./xy-pagelet-container.vue?vue&type=template&id=c4487a00"
import script from "./xy-pagelet-container.vue?vue&type=script&lang=js"
export * from "./xy-pagelet-container.vue?vue&type=script&lang=js"
import style0 from "./xy-pagelet-container.vue?vue&type=style&index=0&id=c4487a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports